import PageHeader from 'components/common/PageHeader';
import AdvanceTablePagination from 'components/common/usersTable/AdvanceTablePagination';
import dayjs from 'dayjs';
import moment from 'moment';
import 'moment/locale/es';
import { useEffect, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getBranchOfficesByUserId } from 'redux/branchOfficeSlice';
import { getSharedProjects } from 'redux/projectsSlice';
import { getRealEstateByUserId } from 'redux/realEstateSlice';
import { informacion } from '../gestionarPropiedades/propertyWizard/steps/data/props';
import ListFilterComponent from './tables/components/ListFilterComponent';
import ListOrderComponent from './tables/components/ListOrderComponent';
import SharedCards from './tables/SharedCards';
import SelectShareBar from '../gestionarPropiedades/tables/propertiesTable/components/SelectShareBar/SelectShareBar';

moment.locale('es');

export const propStatusObj = {
  pending: 'Pendiente',
  published: 'Activa',
  paused: 'Pausada',
  deleted: 'Eliminada',
  finished: 'Finalizada'
};

const SharedProjects = () => {
  //Hooks e informacion base del usuario
  const dispatch = useDispatch();
  const userLogged = useSelector(state => state.login.currentUser);
  const realEstate = useSelector(state => state.realEstate.realEstate);

  //Estado base
  const [data, setData] = useState();

  //Estado para oficina actual y lista de props
  const { neighborhoodsObj } = useSelector(state => state.props);
  const { sharedProjects: projects } = useSelector(state => state.projects);

  const [loading, setLoading] = useState(true);
  const [checkChanges, setCheckChanges] = useState(false);
  //Estados para paginacion
  const [page, setPage] = useState({ number: 1 });
  const [propsLimit, setPropsLimit] = useState(6);
  const [totalProps, setTotalProps] = useState(0);
  const [filtersAndSort, setFiltersAndSort] = useState({
    status: [],
    propertyTypes: [],
    operation: 0,
    shared: 'all',
    price: {
      min: '',
      max: '',
      currency: 'ARS'
    },
    surface: {
      min: '',
      max: '',
      type: 'totalSurface'
    },
    sortBy: {
      prop: 'updated_at',
      order: 'asc'
    },
    neighborhoods: [],
    realEstates: [],
    ambiences: [],
    bedrooms: [],
    bathrooms: [],
    garages: [],
    deadline: {
      from: '',
      to: ''
    }
  });

  //Estado para búsqueda
  const [searchProp, setSearchProp] = useState('');
  const [searchAddress, setSearchAddress] = useState('');

  //filtrado y sort de propiedades mostradas
  const [filtredProps, setFiltredProps] = useState(projects?.list);

  const [type, setType] = useState('cards');

  //Get real estate
  useEffect(() => {
    userLogged?.id && dispatch(getRealEstateByUserId(userLogged.id));
    userLogged && dispatch(getBranchOfficesByUserId(userLogged.id));
  }, [userLogged]);

  //Get props
  useEffect(() => {
    const fetchSharedProjects = async () => {
      if (page && filtersAndSort && propsLimit && realEstate?.id) {
        setLoading(true);
        try {
          await dispatch(
            getSharedProjects(
              filtersAndSort,
              page.number,
              propsLimit,
              searchProp,
              searchAddress,
              realEstate.id
            )
          );
        } catch (error) {
          console.error('No se pudieron cargar los proyectos', error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchSharedProjects();
  }, [
    page,
    filtersAndSort,
    propsLimit,
    searchProp,
    searchAddress,
    realEstate,
    dispatch
  ]);

  useEffect(() => {
    setPage({ number: 1 });
  }, [filtersAndSort, propsLimit, searchProp, searchAddress, realEstate]);

  //inicializo las dos listas de propiedades en base a la lista actual
  useEffect(() => {
    if (projects) {
      setFiltredProps(projects.list);
      setTotalProps(projects?.length || 0);
    }
  }, [projects]);

  // State con array de elementos seleccionados
  const [selected, setSelected] = useState([]);

  const canNextPage = Math.ceil(totalProps / propsLimit) > page.number;
  const canPreviousPage = page.number > 1;

  const nextPage = () => {
    setPage(prev => ({ number: prev.number + 1 }));
  };

  const previousPage = () => {
    setPage(prev => ({ number: prev.number - 1 }));
  };

  const submitSearch = value => setSearchProp(value);
  const submitSearchAddress = value => setSearchAddress(value);

  const HandleCheckbox = () => {
    if (selected.length > 0) setSelected([]);
    else
      setSelected(
        data.map(proj => ({
          id: proj.id,
          title: proj.title,
          status: proj.status
        }))
      );
  };

  useEffect(() => {
    if (filtredProps) {
      const array = filtredProps?.map(proj => {
        return {
          id: proj._id,
          title: proj.title,
          images: proj.images,
          address: `${proj.location.street} ${proj.location.number}`,
          barrios: neighborhoodsObj[proj.location.barrios?.at(-1)],
          operation: `${informacion.operation[proj.operation_type]}`,
          updated_at: dayjs(proj.updated_at).format('DD/MM/YYYY HH:mm [hs]'),
          created_at: dayjs(proj.updated_at).format('DD/MM/YYYY HH:mm [hs]'),
          type: informacion.property[proj.property_type],
          share: proj.share,
          locality: proj.location.locality,
          units: proj.units,
          real_estate: proj.real_estate,
          info: proj.info,
          branch_office: proj.branch_office
        };
      });

      setData(array);
    }
  }, [filtredProps]);

  return (
    <>
      {userLogged && (
        <>
          <PageHeader
            title="Emprendimientos Compartidos"
            description="Listado de emprendimientos compartidos por otras inmobiliarias."
            className="mb-3 bg-white"
          />

          <Row className="g-3">
            <Col xs={12} lg={3} xxl={2}>
              <ListFilterComponent
                filtersAndSort={filtersAndSort}
                setFiltersAndSort={setFiltersAndSort}
                submitSearch={submitSearch}
                searching={!!searchProp}
                searchAddress={submitSearchAddress}
                searchingAddress={!!searchAddress}
                noBranchOffice
                noStatus
                noShared
                showCharacteristics
                neighborhoods={projects.neighborhoods}
                realEstates={projects.realEstates}
              />
            </Col>

            <Col xs={12} lg={9} xxl={10}>
              <Row className="g-1">
                <Col xs={12}>
                  <ListOrderComponent
                    type={type}
                    setType={setType}
                    page={page.number}
                    propsLimit={Number(propsLimit)}
                    setPropsLimit={setPropsLimit}
                    totalProps={totalProps}
                    filtersAndSort={filtersAndSort}
                    setFiltersAndSort={setFiltersAndSort}
                    noSwitch
                    rowsPerPageOptions={[6, 12, 18, 24, 32, 48]}
                    loading={loading}
                  />
                </Col>

                <Col xs={12}>
                  <SelectShareBar
                    selected={selected}
                    setSelected={setSelected}
                    handleCheckbox={HandleCheckbox}
                    type="project"
                  />
                </Col>

                {loading ? (
                  <Col xs={12} className="d-flex justify-content-center py-5">
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '48vh'
                      }}
                    >
                      <Spinner
                        animation="border"
                        style={{
                          color: '#2c7be5'
                        }}
                      />
                    </div>{' '}
                  </Col>
                ) : (
                  <>
                    <SharedCards
                      projects={data}
                      setFiltredProps={setFiltredProps}
                      type={type}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Col xs={12} className="pt-2">
                      {data && data.length > 0 && (
                        <AdvanceTablePagination
                          canNextPage={canNextPage}
                          canPreviousPage={canPreviousPage}
                          pageCount={Math.ceil(totalProps / propsLimit)}
                          gotoPage={page => setPage({ number: page + 1 })}
                          nextPage={nextPage}
                          pageIndex={page.number - 1}
                          previousPage={previousPage}
                          setCheckChanges={setCheckChanges}
                        />
                      )}
                    </Col>
                  </>
                )}
              </Row>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default SharedProjects;
